import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import localizationStrings from "../../statics/localization";
import ModalPortal from "../modalPortal";
import ProgramDetail from "../programDetail";
import VerticalProgramListItem from "../verticalProgramListItem";
import {
  addRecord,
  getRecordedList,
  getWillBeRecordedList,
  removeRecord
} from "../../api/npvr/npvr";

const VerticalProgramListWidget = ({
  programs,
  fromPlayer,
  onSelectCutvProgram,
  onSelectLive,
  isLocked,
  userRating,
  setSelectedCutvProgram,
  selectedChannel,
  userFrameConfig,
  userInfo,
  location,
  setPlayUrl,
  playUrl,
  hasLoggedIn
}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedProgramCode, setSelectedProgramCode] = useState(null);
  const [selectedProgramdDetail, setSelectedProgramDetail] = useState(null);
  const [npvrStatusByProgram, setNpvrStatusByProgram] = useState({});
  const history = useHistory();

  const resolveProgramId = (program) => {
    return (
      program?.epgProgramId ||
      program?.prevuecode ||
      program?.prevueCode ||
      program?.id ||
      null
    );
  };

  const resolveChannelUId = (program) => {
    return (
      selectedChannel?.id ||
      selectedChannel?.uid ||
      selectedChannel?.channelUId ||
      program?.channelUId ||
      program?.channelId ||
      null
    );
  };

  const refreshNpvrStatuses = async () => {
    try {
      const [recordedRes, recordingRes] = await Promise.all([
        getRecordedList(),
        getWillBeRecordedList()
      ]);

      const statusMap = {};

      (Array.isArray(recordedRes?.data) ? recordedRes.data : []).forEach((item) => {
        const id = resolveProgramId(item);
        if (!id) return;
        statusMap[id] = {
          status: item?.newstatus || "1",
          npvrRecordUId: item?.npvrRecordUId || item?.UId || item?.uId || null
        };
      });

      (Array.isArray(recordingRes?.data) ? recordingRes.data : []).forEach((item) => {
        const id = resolveProgramId(item);
        if (!id) return;
        statusMap[id] = {
          status: item?.newstatus || "0",
          npvrRecordUId: item?.npvrRecordUId || item?.UId || item?.uId || null
        };
      });

      setNpvrStatusByProgram(statusMap);
    } catch (e) {
      setNpvrStatusByProgram({});
    }
  };

  const onToggleRecord = async (program) => {
    const isGuestUser = localStorage.getItem("usertype") === "0";
    if (isGuestUser) return;

    const programId = resolveProgramId(program);
    if (!programId) return;

    const currentStatus = npvrStatusByProgram?.[programId]?.status || "-2";
    const isAlreadyRecorded = ["1", "0", "999"].includes(String(currentStatus));

    try {
      if (isAlreadyRecorded) {
        await removeRecord(
          programId,
          false,
          npvrStatusByProgram?.[programId]?.npvrRecordUId || null,
          resolveChannelUId(program)
        );
      } else {
        await addRecord(
          programId,
          program?.seriesId || null,
          Date.now(),
          false,
          resolveChannelUId(program)
        );
      }
    } catch (e) {
      // Keep list usable even when API errors occur.
    }

    await refreshNpvrStatuses();
  };

  useEffect(() => {
    refreshNpvrStatuses();
  }, [selectedChannel?.id, programs?.length]);

  useEffect(() => {
    const handleNpvrStatusChanged = () => {
      refreshNpvrStatuses();
    };

    window.addEventListener("npvr-status-changed", handleNpvrStatusChanged);
    return () => {
      window.removeEventListener("npvr-status-changed", handleNpvrStatusChanged);
    };
  }, [selectedChannel?.id, programs?.length]);

  const onSelect = (program) => {
    setShowModal(true);
    setSelectedProgramCode(program?.epgProgramId);
    setSelectedProgramDetail(program);
  };

  const renderedItems = programs.map((program, index) => {
    return (
      <VerticalProgramListItem
        key={program?.epgProgramId}
        program={program}
        index={index}
        onSelect={onSelect}
        recordStatus={
          npvrStatusByProgram?.[resolveProgramId(program)]?.status || "-2"
        }
        onToggleRecord={onToggleRecord}
        onSelectCutvProgram={onSelectCutvProgram}
        onSelectLive={onSelectLive}
        isLocked={isLocked}
        userRating={userRating}
        //selectedChannelRating={selectedChannel?.prevueratingid}
      />
    );
  });

  return (
    <>
      {renderedItems?.length ? (
        renderedItems
      ) : (
        <div className="no-program-info">{localizationStrings.noProgram}</div>
      )}

      {!fromPlayer && showModal ? (
        <ModalPortal viewClass="vod-modal">
          <ProgramDetail
            prevueCode={selectedProgramCode}
            closeModal={() => setShowModal(false)}
            fromLive={true}
            setSelectedCutvProgram={setSelectedCutvProgram}
            selectedChannel={selectedChannel}
            userFrameConfig={userFrameConfig}
            userInfo={userInfo}
            location={location}
            history={history}
            programData={selectedProgramdDetail}
            setPlayUrl={setPlayUrl}
            playUrl={playUrl}
            hasLoggedIn={hasLoggedIn}
          />
        </ModalPortal>
      ) : null}
    </>
  );
};

export default VerticalProgramListWidget;
